import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { BiCheck } from 'react-icons/bi';
import { isEmpty } from 'lodash';

import EmptyState from 'modules/common/components/EmptyState';
import { Button, FormInputCheckBox } from 'modules/common/input';
import Pagination from 'modules/common/components/Pagination';
import PageLoader from 'modules/common/components/PageLoader';
import { useGetDiscounts } from 'modules/branch/services-management/settings/hooks';

import { useGetCart } from '../../hooks';
import CartRow from '../cart/CartRow';

const DEFAULT_FILTER = {
  per_page: 25,
  page: 1,
};

function DiscountModal({ onClose, onChange, value }) {
  const [form, setForm] = React.useState(value);
  const [filter, setFilter] = React.useState(DEFAULT_FILTER);
  const [showCart, setShowCart] = React.useState(false);

  const [cart, setCart, includes] = useGetCart();
  const [isListLoading, list, pagination] = useGetDiscounts({
    params: filter,
  });

  const handleOnProceed = () => {
    // eslint-disable-next-line no-constant-condition
    if (form?.apply_discount || true) {
      onChange({ ...form, selected_orders: [] });
      setCart((prevState) =>
        prevState?.map((item) => ({
          ...item,
          discount_type: form?.discount_type,
        }))
      );
      onClose();

      return;
    }

    if (showCart) {
      onChange(form);
      setCart((prevState) =>
        prevState?.map((item, key) => {
          if (
            (form?.selected_orders || [])?.findIndex(
              (subItem) => subItem?.$key === key
            ) > -1
          ) {
            return {
              ...item,
              discount_type: form?.discount_type,
            };
          }

          return {
            ...item,
            discount_type: null,
          };
        })
      );
      onClose();

      return;
    }

    setShowCart(!showCart);
  };
  const handleOnChangePage = (page) => {
    setFilter((prevState) => ({
      ...prevState,
      page,
    }));
  };
  const handleOnClose = () => {
    if (showCart) {
      setShowCart(!showCart);
      return;
    }

    onClose();
  };
  const handleOnCheck = (row, index) => () => {
    const existsIndx = (form?.selected_orders || [])?.findIndex(
      (item) => item?.$key === index
    );

    if (existsIndx > -1) {
      setForm((prevState) => ({
        ...prevState,
        selected_orders: (prevState?.selected_orders || [])?.filter(
          (item, key) => key !== existsIndx
        ),
      }));

      return;
    }

    setForm((prevState) => ({
      ...prevState,
      selected_orders: [
        ...(prevState?.selected_orders || []),
        {
          ...row,
          $key: index,
        },
      ],
    }));
  };
  const handleOnAddDiscount = (row) => () => {
    setForm((prevState) => ({
      ...prevState,
      discount_type: [row],
    }));
  };

  React.useEffect(() => {
    setForm(value);
  }, [value]);

  if (isListLoading && list?.length <= 0) return <PageLoader />;

  return (
    <div className="space-y-3">
      {showCart ? (
        <div className="min-h-[300px] max-h-[300px] overflow-y-auto overflow-x-hidden space-y-2 p-2 -m-2 -mt-4">
          {cart?.length > 0 ? (
            cart?.map((item, key) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={key}
                role="presentation"
                onClick={handleOnCheck(item, key)}
                className={cn(
                  'flex items-center gap-3 cursor-pointer border p-3 rounded',
                  {
                    'border-primary-500 bg-primary-50': !isEmpty(
                      (form?.selected_orders || [])?.find(
                        (subItem) => subItem?.$key === key
                      )
                    ),
                  }
                )}
              >
                <div>
                  <FormInputCheckBox
                    id={`cart-${key}`}
                    name="cart-checkbox"
                    onChange={handleOnCheck(item, key)}
                    checked={
                      !isEmpty(
                        (form?.selected_orders || [])?.find(
                          (subItem) => subItem?.$key === key
                        )
                      )
                    }
                    label=""
                  />
                </div>
                <div>
                  <CartRow
                    data={item}
                    withRemove={false}
                    includes={includes}
                    withPrice={false}
                    isWhiteBg
                  />
                </div>
              </div>
            ))
          ) : (
            <EmptyState />
          )}
        </div>
      ) : (
        <>
          <div className="min-h-[300px] max-h-[300px] overflow-y-auto overflow-x-hidden space-y-3">
            {list?.length > 0 ? (
              list?.map((item, key) => (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={key}
                  className={cn(
                    'card p-3 font-medium flex items-center gap-2 cursor-pointer text-sm',
                    {
                      '!bg-primary-50 !border-primary-500':
                        form?.discount_type?.findIndex(
                          (subItem) => subItem?.key === item?.key
                        ) > -1,
                    }
                  )}
                  onClick={handleOnAddDiscount(item)}
                  role="presentation"
                >
                  <div className="w-8 h-7">
                    {form?.discount_type?.findIndex(
                      (subItem) => subItem?.key === item?.key
                    ) > -1 && <BiCheck className="h-7 w-7 text-primary-500" />}
                  </div>
                  <div>
                    {item?.name} ({item?.value}%)
                  </div>
                </div>
              ))
            ) : (
              <EmptyState />
            )}
          </div>

          <div>
            <Pagination
              value={pagination}
              small
              onChange={handleOnChangePage}
              isLoading={isListLoading}
            />
          </div>
        </>
      )}

      <div className="flex gap-3 md:gap-0 md:items-center flex-col md:flex-row">
        {/* {!showCart && (
          <div>
            <FormInputCheckBox
              name="apply_discount"
              label="Apply discount to whole order"
              onChange={setForm}
              checked={form?.apply_discount}
            />
          </div>
        )} */}

        <div className="md:ml-auto flex-shrink-0">
          <div className="flex gap-2 items-center">
            <div
              className={cn(
                'flex-1 md:flex-initial',
                showCart ? 'md:w-24' : 'md:w-20'
              )}
            >
              <Button
                label={showCart ? 'Go Back' : 'Cancel'}
                onClick={handleOnClose}
                className="btn gray bg-gray-100 font-semibold w-full"
              />
            </div>
            <div
              className={cn(
                'flex-1 md:flex-initial'
                // form?.apply_discount || showCart ? 'md:w-[135px]' : 'md:w-24'
              )}
            >
              <Button
                label={
                  <div className="flex-shrink-0">
                    Apply Discount
                    {/* {form?.apply_discount || showCart
                      ? 'Apply Discount'
                      : 'Proceed'} */}
                  </div>
                }
                onClick={handleOnProceed}
                className="btn primary font-semibold w-full"
                disabled={
                  list?.length <= 0 ||
                  form?.discount_type?.length <= 0 ||
                  (showCart && (form?.selected_orders || [])?.length <= 0)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

DiscountModal.defaultProps = {
  onClose: () => {},
  onChange: () => {},
  value: {},
};

DiscountModal.propTypes = {
  onClose: PropTypes.instanceOf(Function),
  onChange: PropTypes.instanceOf(Function),
  value: PropTypes.instanceOf(Object),
};

export default DiscountModal;
